<template>
  <div>
    <div class="row mt-12">
      <div class="col-md-2">
        <label>Nº Chamado</label>
        <input type="text" class="form-control filter-input" v-model="filters.id" />
      </div>
      <div class="col-md-8">
        <label>Título</label>
        <input type="text" class="form-control filter-input" v-model="filters.title" />
      </div>
      <div class="col-md-2">
        <label>Prazo</label>
        <input
          type="date"
          class="form-control filter-input"
          v-model="filters.deadline"
          placeholder="Selecione o prazo"
          />
        </div>
        <div class="col-md-4 mt-1">
          <label>Status</label>
          <v-select
            class="filter-select"
            v-model="filters.status"
            :options="status_calls"
            :reduce="(status_calls) => status_calls.id"
            :label="'description'"
          ></v-select>
        </div>
        <div class="col-md-4 mt-1">
          <label>Solicitante</label>
          <v-select
            class="filter-select"
            v-model="filters.user_id"
            :options="users"
            :reduce="(users) => users.id"
            :label="'name'"
           ></v-select>
        </div>
        <div class="col-md-4 mt-1">
          <label>Sistema</label>
            <v-select
            class="filter-select"
            v-model="filters.system_error_id"
            :options="systems"
            :reduce="(systems) => systems.id"
            :label="'name'"
            placeholder="Selecione o sistema"
          ></v-select>
        </div>
  </div>
    <div class="row mt-2">
      <!-- Botões de Filtrar e Limpar Filtros -->
      <div class="col-md-4 d-flex align-items-end">
        <button class="btn btn-primary mr-2" @click="getMyCalls">
          Filtrar
        </button>
        <button class="btn btn-secondary" @click="clearFilters">
          Limpar Filtros
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="card content-crud">
          <div class="ibox">
            <div class="ibox-title" style="padding: 16px">
              <h3>Meus Chamados: {{ my_calls.length }}</h3>
              </div>
                <div class="ibox-content">
                      <table
                         class="VueTables__table table table-striped table-bordered table-hover"
                         style="padding: 10px; width: 100%; table-layout: fixed;"
                      >
                        <thead>
                           <tr>
                             <th scope="col" style="width: 28%">CHAMADO</th>
                             <th scope="col" style="width: 12%">PRIORIDADE</th>
                             <th scope="col" style="width: 13%">STATUS</th>
                             <th scope="col" style="width: 17%">PESSOAS</th>
                             <th scope="col" style="width: 19%">PRAZO</th>
                             <th scope="col" style="width: 11%">AÇÕES</th>
                            </tr>
                          </thead>
                                <tbody>
                                  <tr v-for="my_call in my_calls" :key="my_call.id">
                                    <!-- CHAMADO: nº + título + sistema/data -->
                                  <td>
                                    <div>
                                      <strong>#{{ my_call.id }}</strong>
                                      {{ removePTags(my_call.title) }}
                                    </div>
                                      <small class="text-muted">
                                        {{ my_call.project.name }} · {{ my_call.created_at_f }}
                                      </small>
                                  </td>

                                <td class="text-center">{{ my_call.priority }}</td>

                                <td>{{ my_call.status_calls.description }}</td>

                                <td>
                                  <div>
                                    {{ my_call.user_model ? my_call.user_model.name : "" }}
                                  </div>
                                  <small class="text-muted">
                                    <template v-if="my_call.last_interaction">
                                      últ. {{ my_call.last_interaction.user.name }} ·
                                      {{ my_call.last_interaction.created_at_f }}
                                    </template>
                                    <template v-else>
                                      Não houve interações neste chamado
                                    </template>
                                  </small>
                                </td>

                                <td class="text-center">
                                  <span
                                    v-if="my_call.deadline"
                                    :class="'badge badge-' + deadlineStatus(my_call.deadline)"
                                    style="font-size: 13px; padding: 6px 10px"
                                  >
                                    <i class="far fa-clock mr-1"></i>
                                    {{ my_call.deadline_f }}
                                  </span>

                                  <span v-else class="text-muted">
                                    <i class="far fa-clock mr-1"></i>
                                    Sem prazo
                                  </span>
                                </td>

                                <td class="text-center">
                                  
                                  <a :href="'/calls/ticket/' + my_call.id" title="Visualizar" class="btn btn-crud view" target="_blank">
                                    <i class="fas fa-eye"></i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                    </table>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";

export default {
  data: function () {
    return {
      filters: {},
      my_calls: [],
      status_calls: [],
      systems: [],
      users: [],
    };
  },
  components: {
    BaseCrud,
    vSelect,
    Pagination,
  },

  methods: {
    clearFilters() {
      this.filters = {
        id: "",
        status: "",
        title: "",
        user_id: "",
        deadline: "", // Reseta o filtro de data
        system_error_id: "", // Reseta o filtro de sistema
      };

      // Atualiza os chamados para exibir todos novamente
      this.getMyCalls();
    },

    removePTags(text) {
      return text.replace(/<\/?p>/g, "");
    },

    removePTags(text) {
  return text.replace(/<\/?p>/g, "");
},

deadlineStatus(deadline) {
  if (!deadline) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const deadlineDate = new Date(deadline);
  deadlineDate.setHours(0, 0, 0, 0);

  const diffDays = (deadlineDate - today) / (1000 * 60 * 60 * 24);

  if (diffDays < 0) return "danger";
  if (diffDays <= 3) return "warning";
  return "success";
},

    getMyCalls() {
      const self = this;

      let api = self.$store.state.api + "my-calls";

      self.$loading(true);
      axios
        .post(api, self.filters)
        .then((response) => {
          self.my_calls = response.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getStatusCalls: function () {
      const self = this;
      const api = self.$store.state.api + "statusCall?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.status_calls = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getProjects: function () {
      const self = this;
      const api = self.$store.state.api + "projects?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.systems = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getMyCalls();
    this.getStatusCalls();
    this.getProjects();
    this.getUsers();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}

.filter-input {
  height: 38px;
}

.filter-select ::v-deep .vs__dropdown-toggle {
  height: 38px;
  display: flex;
  align-items: center;
}

.filter-select ::v-deep .vs__selected-options {
  padding: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}

.filter-select ::v-deep .vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
